import Page from '../pages/model'
import api from '@/helpers/api'
import { ADMIN, ENGINEER, STUDENT } from './model'
import { TYPE_CPO, TYPE_DCS, TYPE_DIRECTION } from '../organizations/model'
import { find, get } from 'lodash'

const rules = [
    {role: STUDENT, organizationType: [TYPE_CPO]},
    {role: ADMIN, organizationType: [TYPE_CPO, TYPE_DCS, TYPE_DIRECTION]},
    {role: ENGINEER, organizationType: [TYPE_CPO]},
];

export default {
    state: {

    },

    mutations: {

    },

    getters: {
        getOrganizationTypesBySysname (state, getters) {
            return role => {
                return get(find(rules, {role: role}), 'organizationType', [])
            }
        },
    },

    actions: {
        fetchItems (store, params) {
            Page.dispatch('addLoader', 'roles.fetchItems')

            return api.get('/api/v1/dictionaries/Role', {params})
            .then(res => {
                store.dispatch('insertOrUpdate', { data: res.data.data })
                return res.data
            }).finally(()=>{
                Page.dispatch('removeLoader', 'roles.fetchItems')
            })
        },
    }
}
